<template>
    <div class="form-row">
        
        <channel-filter
            :extra-filters="extraFilters"
            :translations="translations"
            @onFilter="changeExtraFilter($event)"
            v-if="extraFilters.channels != undefined"
        ></channel-filter>

        <locale-filter
            :extra-filters="extraFilters"
            :translations="translations"
            @onFilter="changeExtraFilter($event)"
            v-if="extraFilters.locales != undefined"
        ></locale-filter>

        <customer-group-filter
            :extra-filters="extraFilters"
            :translations="translations"
            @onFilter="changeExtraFilter($event)"
            v-if="extraFilters.customer_groups != undefined"
        ></customer-group-filter>

        <slot />

    </div>
</template>

<script>
import ChannelFilter from '../filters/channel-filter';
import CustomerGroupFilter from '../filters/customer-group-filter';
import LocaleFilter from '../filters/locale-filter';

export default {
    props: ['extraFilters', 'translations'],

    components: {
        ChannelFilter,
        CustomerGroupFilter,
        LocaleFilter
    },

    methods: {
        changeExtraFilter($event) {
            this.$emit('onFilter', $event);
        }
    }
};
</script>
